import { isClient } from 'helpers/isServer';
import { useCurrentUserData } from 'hooks/user/useCurrentUserData';
import { useEffect, useState } from 'react';
import { UserSlice } from 'store/slices/createUserSlice';
import { usePersistStore } from 'store/usePersistStore';

export const useSetUserSlice = (userState: Partial<UserSlice>) => {
    const [isConfigSet, setIsConfigSet] = useState(false);
    const [isHydrated, setIsHydrated] = useState(false);
    const { isUserLoggedIn } = useCurrentUserData();
    const updateDefaultStoreUuidState = usePersistStore((state) => state.updateDefaultStoreUuidState);
    const updateCartUuid = usePersistStore((state) => state.updateCartUuid);

    // Subscribe to hydration state
    useEffect(() => {
        if (!isClient) {
            return undefined;
        }

        // Check if already hydrated
        if (usePersistStore.persist.hasHydrated()) {
            setIsHydrated(true);

            return undefined;
        }

        // Subscribe to hydration completion
        const unsubscribe = usePersistStore.persist.onFinishHydration(() => {
            setIsHydrated(true);
        });

        return unsubscribe;
    }, []);

    /**
     * Wait for store hydration before updating values to prevent overwriting
     * persisted data with initial null values.
     */
    useEffect(() => {
        if (!isHydrated || isConfigSet) {
            return;
        }

        updateDefaultStoreUuidState(userState.defaultStoreUuid ?? null);
        updateCartUuid(isUserLoggedIn ? null : userState.cartUuid ?? null);
        setIsConfigSet(true);
    }, [
        isHydrated,
        isConfigSet,
        isUserLoggedIn,
        updateCartUuid,
        updateDefaultStoreUuidState,
        userState.cartUuid,
        userState.defaultStoreUuid,
    ]);
};
